import { render, staticRenderFns } from "./ContentApprovedMessage.vue?vue&type=template&id=6a0274f8"
import script from "./ContentApprovedMessage.vue?vue&type=script&lang=js"
export * from "./ContentApprovedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports